import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ChevronDown, ChevronUp, User, 
  FileText, LogOut
} from "lucide-react";

import {
  getUsuarioByUser_Id, getUsers, getIncidenteById, 
  getClienteProveedorById, getClienteProveedor, getTipoIncidenteById,
  getTipoUbicacionById, getProductoById, getProductos, getMaterialById,
  getMarcaById, createMarca, getFamiliaById, getUsuarioById,
  getUbicacionById, //getKitById
} from "../api";

import FilterTableIncidenteVer from "./FilterTableIncidenteVer";
import FilterTableTipoIncidente from "./FilterTableTipoIncidente";
import FilterTableTipoUbicacion from "./FilterTableTipoUbicacion";
import FilterTableProducto from "./FilterTableProducto";
import FilterTableMaterial from "./FilterTableMaterial";
import FilterTableMarca from "./FilterTableMarca";
import FilterTableFamilia from "./FilterTableFamilia";
import FilterTableFactura from "./FilterTableFactura";
import FilterTableGestionUsuarios from "./FilterTableGestionUsuarios";
import FilterTableUbicacion from "./FilterTableUbicacion";
import FilterTableClienteProveedor from "./FilterTableClienteProveedor";
import CambiarContrasena from "./CambiarContrasena";

const menuOptions = [
  { id: "incidente", label: "Incidentes", icon: <FileText size={20} /> },
  { id: "gestion_usuarios", label: "Gestion Usuarios", icon: <User size={20} /> },
  { id: "cambiar_contrasena", label: "Cambiar contraseña", icon: <User size={20} /> }
];

const Finanzas = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = location.state || {};

  const [entities, setEntities] = useState({});
  const [loading, setLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [selectedSection, setSelectedSection] = useState("gestion_usuarios");

  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  const loadData = useCallback(async (entity, apiCall) => {
    try {
      const { data } = await apiCall();
      setEntities(prev => ({ ...prev, [entity]: data }));
    } catch (error) {
      console.error(`Error loading ${entity}:`, error);
    }
  }, []);

  useEffect(() => {
    if (userData) {
      loadData("usuario", () => getUsuarioByUser_Id(userData[0].id_usuario));
      loadData("incidente", getIncidenteById);
      loadData("cliente_proveedor", getClienteProveedorById);
      loadData("tipo_incidente", getTipoIncidenteById);
      loadData("tipo_ubicacion", getTipoUbicacionById);
      loadData("producto", getProductoById);
      loadData("material", getMaterialById);
      loadData("marca", getMarcaById);
      loadData("familia", getFamiliaById);
      loadData("factura", getFamiliaById);
      loadData("usuario", getUsuarioById);
      loadData("ubicacion", getUbicacionById);
      setLoading(false);
    }
  }, [loadData, userData]);

  const renderSection = () => {
    switch (selectedSection) {
      case "gestion_usuarios":
        return <FilterTableGestionUsuarios />;
      case "incidente":
        return <FilterTableIncidenteVer incidentes={entities.incidente} fetchClienteProveedor={getClienteProveedor} />;
      case "producto":
        return <FilterTableProducto productos={entities.producto} fetchProductos={getProductos} fetchUsuarios={getUsers} />;
      case "material":
        return <FilterTableMaterial material={entities.material} />;
      case "marca":
        return <FilterTableMarca marca={entities.marca} />;
      case "familia":
        return <FilterTableFamilia familia={entities.familia} />;
      case "factura":
        return <FilterTableFactura factura={entities.factura} />;
      case "cliente_proveedor":
        return <FilterTableClienteProveedor cliente_proveedor={entities.cliente_proveedor} />;
      case "ubicacion":
        return <FilterTableUbicacion ubicacion={entities.ubicacion} />;
      case "tipo_incidente":
        return <FilterTableTipoIncidente tipo_incidente={entities.tipo_incidente} />;
      case "tipo_ubicacion":
        return <FilterTableTipoUbicacion tipo_ubicacion={entities.tipo_ubicacion} />;
      case "cambiar_contrasena":
        return <CambiarContrasena />;
      default:
        return <div>Seleccione una sección: {selectedSection}</div>;
    }
  };

  return (
    <div>
      {loading ? (
        <div className="loader"></div>
      ) : (
        <div className="container-principal">
          <h5>Finanzas</h5>

          {/* Menu lateral */}
          <div className={`menu-bar ${isMenuOpen ? "expanded" : "collapsed"}`}>
          <img
              className="img-banner"
              alt="Adser consorcio"
              src={isMenuOpen ? "/adser_logo_bn.png" : "/adser_logo_collapsed.png"}
              width="150"
              height="40"
            />

            <button className="toggle-menu" onClick={toggleMenu}>
              {isMenuOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </button>

            <div className="menu-content">
              {menuOptions.map(({ id, label, icon }) => (
                <button key={id} className="menu-button" onClick={() => setSelectedSection(id)}>
                  {isMenuOpen ? label : icon}
                </button>
              ))}
              <button className="menu-button" onClick={() => navigate("/")}>
                {isMenuOpen ? "Salir" : <LogOut size={20} />}
              </button>
            </div>
          </div>

          {/* Contenido principal */}
          <div>{renderSection()}</div>
        </div>
      )}
    </div>
  );
};

export default Finanzas;
